import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";
import { fetchService } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsCampaignUtils";
import type { ISearchTrafficData, ISearchTrafficDataCompare } from "./types";

const SEARCH_TRAFFIC_QUERY_KEY = "SEARCH_TRAFFIC_DATA";

interface ISearchTrafficParams {
    country: number;
    includeSubDomains: boolean;
    keys: string;
    timeGranularity: string;
    webSource: string;
    from: string;
    to: string;
    isWindow: boolean;
}

async function fetchSearchTrafficData(params: ISearchTrafficParams | ISearchTrafficDataCompare) {
    try {
        const response = await fetchService.get(`/widgetApi/MarketingMixTotal/TrafficSourcesOverview/BarChart`, {
            ...params,
        });
        return response;
    } catch (error) {
        Sentry.error(`Error fetching 'cost per visit' Data`, error);
    }
}

export function useSearchTrafficData(params: ISearchTrafficParams | ISearchTrafficDataCompare, enabled = true): UseQueryResult<{ Data: ISearchTrafficData }> {
    return useQuery({
        queryKey: [SEARCH_TRAFFIC_QUERY_KEY, params],
        queryFn: () => fetchSearchTrafficData(params),
        enabled,
        staleTime: Infinity,
    });
}
